export default "__VITE_ASSET__CT9ftQi4__"